@if (facets() && facets().length) {
  <app-multi-facet-pills
    [facets]="facets()"
    [selectedFacets]="selectedFacets()"
    (selected)="onFilter($event)
">
  </app-multi-facet-pills>
}
